"use client"
// import YoutubeVideo from "./YoutubeVideo"
// import VidyardVideo from "./VidyardVideo"
import dynamic from "next/dynamic"

const VidyardVideo = dynamic(() => import("./VidyardVideo"), {
  ssr: false,
  loading: () => (
    <div className="aspect-video bg-gray-900 animate-pulse flex items-center justify-center">
      <svg
        className="w-16 h-16 text-white"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
      </svg>
    </div>
  ),
})

const YoutubeVideo = dynamic(() => import("./YoutubeVideo"), {
  ssr: false,
  loading: () => (
    <div className="aspect-video bg-gray-900 animate-pulse flex items-center justify-center">
      <svg
        className="w-16 h-16 text-white"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
      </svg>
    </div>
  ),
})

export interface Video {
  videoId?: string
  animationMode?: boolean // animation mode will only be available for Vimeo videos
  autoplay?: boolean
  // if the detection is wrong, then you can use this to force the video type
  forceVideoType?: "youtube" | "vidyard"
  isNoDescription?: boolean
  fullBackgroundVideo?: boolean
  forceFullHeightVideo?: boolean
}

const getVideo = (
  videoId: string,
  animationMode: boolean,
  autoplay: boolean,
  isNoDescription?: boolean,
  fullBackgroundVideo?: boolean,
  forceFullHeightVideo?: boolean,
) => {
  // Cover-fit and hero sizing only apply to flexible-hero background videos.
  const heroForceFullHeight = !!fullBackgroundVideo && !!forceFullHeightVideo
  // Background hero videos must be muted for browser autoplay policies.
  const effectiveMuted = !!fullBackgroundVideo
  const effectiveControls = !fullBackgroundVideo
  const effectiveLoop = !!fullBackgroundVideo
  const youtubeRegex =
    /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/im
  const youtubeCodeRegex = /^[a-z,0-9,_,-]{11}$/gim
  const _wistiaCodeRegex = /^[a-z,0-9,_,-]{10}$/gim
  const _vimeoCodeRegex = /[1-9]{8}/gim
  const youtubePlaylistCodeRegex = /[a-z,0-9,_,-]{34}$/gim
  const vidyardCodeRegex = /[a-z,0-9,_,-]{22}$/gim

  // Vidyard sometimes will be https://videos.trimble.com/watch/videoId
  const videoCode =
    videoId
      .trim()
      .replace("https://videos.trimble.com/watch/", "")
      .split("?")[0] || ""

  const youtubeRegexMatches = videoId.match(youtubeRegex)
  const youtubeRegexMatchId = youtubeRegexMatches?.[6]
  // const wistiaRegexMatches = videoId.match(wistiaCodeRegex)
  // const vimeoRegexMatches = videoId.match(vimeoCodeRegex)

  // return (<div>{videoCode}</div>)

  if (youtubeRegexMatchId) {
    // if youtube
    // console.log('youtubeRegexMatchId', youtubeRegexMatchId)
    return (
      <YoutubeVideo
        videoId={youtubeRegexMatchId}
        isNoDescription={isNoDescription}
        autoplay={autoplay}
        muted={effectiveMuted}
        controls={effectiveControls}
        loop={effectiveLoop}
        fullBackgroundVideo={fullBackgroundVideo}
        forceFullHeightVideo={heroForceFullHeight}
      />
    )
  }
  if (youtubeCodeRegex.test(videoCode)) {
    // if youtube
    return (
      <YoutubeVideo
        videoId={videoCode}
        isNoDescription={isNoDescription}
        autoplay={autoplay}
        muted={effectiveMuted}
        controls={effectiveControls}
        loop={effectiveLoop}
        fullBackgroundVideo={fullBackgroundVideo}
        forceFullHeightVideo={heroForceFullHeight}
      />
    )
  }
  if (youtubePlaylistCodeRegex.test(videoCode)) {
    // if youtube playlist
    const playlistId = `?listType=playlist&list=${videoCode}`
    return (
      <YoutubeVideo
        videoId={playlistId}
        isNoDescription={isNoDescription}
        autoplay={autoplay}
        muted={effectiveMuted}
        controls={effectiveControls}
        loop={effectiveLoop}
        fullBackgroundVideo={fullBackgroundVideo}
        forceFullHeightVideo={heroForceFullHeight}
      />
    )
  }
  if (vidyardCodeRegex.test(videoCode)) {
    // if vidyard
    return (
      <VidyardVideo
        videoId={videoCode}
        isNoDescription={isNoDescription}
        autoplay={autoplay}
        fullBackgroundVideo={fullBackgroundVideo}
        forceFullHeightVideo={heroForceFullHeight}
        muted={effectiveMuted}
      />
    )
  }

  return <div>Video not supported</div>
}

/**
 * Primary UI component for user interaction
 */
export const Video = ({
  videoId,
  animationMode = false,
  autoplay = false,
  isNoDescription,
  fullBackgroundVideo = false,
  forceFullHeightVideo = false,
}: Video) => {
  const animationModeClass = animationMode ? " animation-mode" : ""
  const fullBackgroundVideoClass = fullBackgroundVideo
    ? `t2-video-base--background w-full${
        forceFullHeightVideo
          ? " h-full min-h-full t2-video-base--background--full-height"
          : ""
      }`
    : ""
  return (
    <div
      className={`t2-video-base${animationModeClass} ${fullBackgroundVideoClass}`}
    >
      {getVideo(
        videoId || "",
        animationMode,
        autoplay,
        isNoDescription,
        fullBackgroundVideo,
        forceFullHeightVideo,
      )}
      {/* <YoutubeVideo videoId={videoId || ""} /> */}
    </div>
  )
}
